// src/pages/Documentacion.js
import React, { useState } from 'react';
import FolderTree from '../Componentes/Documentacion/FolderTree';
import DocumentList from '../Componentes/Documentacion/DocumentList';
import UploadDocument from '../Componentes/Documentacion/UploadDocument'; // suponiendo que ya lo tienes
import { useNavigate, useParams} from 'react-router-dom'; // si usas react-router
import GetUserData from '../Hooks/GetUserData';
import { FaCog, FaEye } from 'react-icons/fa';
import { GetHubInfo } from '../Hooks/UseHubName';


const Documentacion = () => {
  const [selectedFolderId, setSelectedFolderId] = useState(null);
  const [selectedFolderName, setSelectedFolderName] = useState('');
  const navigate = useNavigate(); // para el botón de volver atrás
  const { hubId } = useParams();
  const {userData} = GetUserData();
  const hubData = GetHubInfo(hubId);


  return (
    <div className="lobby-container">
      {/* Header */}
<div className="header-container">
  <header className="header">
    <h1 className="header-title">Documentación</h1>

    <div className="logout-button-container">
      {(userData?.hubId?.includes("__superadmin__") || hubData?.superUsers?.includes(userData?.uid))&& (
        <div className="admin-buttons">
          <button
            className="logout-button config-button"
            onClick={() => navigate(`/documentacion/${hubId}/permisos`)}
          >
            <FaCog className="logout-icon" />
          </button>

          <button
            className="logout-button config-button"
            onClick={() => navigate(`/documentacion/${hubId}/visualizador`)}
          >
            <FaEye className="logout-icon" />
          </button>
        </div>
      )}

      <button onClick={() => navigate(-1)} className="logout-button">
        ← Volver
      </button>
    </div>
  </header>
</div>


      {/* Contenido principal */}
      <div className="dashboard-grid">
        {/* Columna izquierda: Árbol de carpetas */}
        <div className="dashboard-column">
          <div className="data-box">
            <h2 className="data-box-title">Carpetas</h2>
            <FolderTree
            onSelectFolder={(folderName, folderId) => {
                setSelectedFolderName(folderName);
                setSelectedFolderId(folderId);
            }}
            />
          </div>
        </div>

        {/* Columna derecha: Documentos y subida */}
        <div className="dashboard-column">
          <div className="data-box">
            <h2 className="data-box-title">Documentos en carpeta: {selectedFolderName}</h2>
            {selectedFolderId ? (
              <>
                <UploadDocument folderId={selectedFolderId}  />
                <DocumentList folderId={selectedFolderId} />
              </>
            ) : (
              <p>Selecciona una carpeta para ver o subir documentos.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Documentacion;
